// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","checkmark":"XkJ4hCfDlR4m","dropdownArrowDown":"_8CDlSHQ7UeDs","dropdownArrowUp":"_9pRmAPO+BSqE"};